// =====================================================================
//  Calc.roadTax — JPJ cukai jalan lookup, shared by the road-tax and
//  car-loan calculators so the cc scale lives in one place and both track
//  the same DB-editable table (Calc.data.roadTax).
//  Deliberately NOT in finance.js: these are jurisdiction rate tables, not
//  generic finance formulas.
// =====================================================================
(function () {
  window.Calc = window.Calc || {};

  const cap = (m) => (m === null || m === undefined) ? Infinity : m;

  // Bracket array for a region + vehicle class + ownership selection.
  function table(rates, sel) {
    const r = (rates && rates.cc && rates.cc[sel.region]) || {};
    if (sel.vclass === 'nonsaloon') return r.nonsaloon || [];
    // East saloon rates don't vary by ownership — fall back to private if unset.
    return (sel.ownership === 'company' ? (r.saloonCompany || r.saloonPrivate) : r.saloonPrivate) || [];
  }

  // annual = base + rate*(cc-(lo-1)) for progressive brackets (rate > 0).
  function cc(brackets, engineCC) {
    if (!Array.isArray(brackets) || !brackets.length) return { base: 0, prog: 0, total: 0, band: null };
    for (const b of brackets) {
      if (engineCC <= cap(b.max)) {
        const prog = b.rate > 0 ? b.rate * (engineCC - (b.lo - 1)) : 0;
        return { base: b.base, prog, total: b.base + prog, band: b };
      }
    }
    const last = brackets[brackets.length - 1];
    const prog = last.rate * (engineCC - (last.lo - 1));
    return { base: last.base, prog, total: last.base + prog, band: last };
  }

  // Convenience for callers that just want a figure from a selection.
  function annual(rates, sel) {
    return cc(table(rates, sel), sel.cc || 0);
  }

  Calc.roadTax = { table, cc, annual };
})();
